<template>
  <div class="keshi">
    <!-- 智透 -->
    <div class="zhitou">
      <div class="title">
        <titleCard title="Intelligent Dialysis — Hemodialysis Management Platform"></titleCard>
      </div>
      <div class="content">
        <div class="left animate__animated wow animate__fadeInLeft" data-wow-duration="1.2s">
          It is designed in strict accordance with the reasonable workflow of the dialysis room, to improve the comprehensive management ability and clinical research level of the hospital, and to help patients manage the whole process of dialysis.</div>
        <div class="right animate__animated wow animate__fadeInRight" data-wow-duration="1s">
          <img src="../../assets/image/News/keshi/keshi1.webp" alt="">
        </div>
      </div>
      <div class="title2">
        <titleCard title="Full-Process Information Management System and Solutions"></titleCard>
      </div>
    </div>
    <!-- 全流程信息化管理体系与解决方案 -->
    <div class="xinxi">
      <div class="header">
        <div class="header-title">Systems and Functions</div>
        <div class="header-content animate__animated wow animate__fadeInUp">
          <ul class="left">
            <li v-for="item in leftList" :key="item.id" @click="clickChange(item)" :id="item.id === glID?'liClick':''">
              {{item.title}}</li>
          </ul>
          <div class="in">
            <div class="pic"><img :src="inList.pic"></div>
            <ul class="txt">
              <li v-for="(item,index) in inList.txt" :key="index">{{item}}</li>
            </ul>
          </div>
          <ul class="right">
            <li v-for="item in rightList" :key="item.id" @click="clickChange(item)"
              :id="item.id === glID?'liClick2':''">
              {{item.title}}</li>
          </ul>
        </div>
        <div class="ios-content">
          <ul class="contentmenu">
            <li v-for="item in IosList" :key="item.id" @click="clickChange(item)" :id="item.id === glID?'liClick':''">
              {{item.title}}</li>
          </ul>
          <div class="in">
            <div class="pic"><img :src="inList.pic"></div>
            <ul class="txt">
              <li v-for="(item,index) in inList.txt" :key="index">{{item}}</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="titletxt">Medical Procedure</div>
        <div class="pc-content">
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="1s">
              <div class="left"><img src="../../assets/image/News/keshi/icon1.webp" alt=""></div>
              <div class="right">
                <h2>Dialysis Preparation</h2>
                <p>EMR Registration&Scheduling <br>Patient Status  Dialysis Types</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="2s">
              <div class="left"><img src="../../assets/image/News/keshi/icon2.webp" alt=""></div>
              <div class="right">
                <h2>Rapid Reception</h2>
                <p>Scheduling  Auto Weighing<br> Treatment Plan  Quick Bind <br>Identification</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="3s">
              <div class="left"><img src="../../assets/image/News/keshi/icon3.webp" alt=""></div>
              <div class="right">
                <h2>On Dialysis</h2>
                <p>Medical Advice Formulation Medical Advice Push Dialysis Monitoring Medical Supplies<br> Dialysis Machine Online</p>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="arrow"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="4s">
              <div class="left"><img src="../../assets/image/News/keshi/icon4.webp" alt=""></div>
              <div class="right">
                <h2>Daily Management</h2>
                <p>Inventory  Equipment<br> Historical Data  Medical Documents</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="5s">
              <div class="left"><img src="../../assets/image/News/keshi/icon5.webp" alt=""></div>
              <div class="right">
                <h2>Statistical Analysis</h2>
                <p>Medical Supplies Expenses<br> Dialysis Record  Final Medical Advice</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn" data-wow-duration="6s">
              <div class="left"><img src="../../assets/image/News/keshi/icon6.webp" alt=""></div>
              <div class="right">
                <h2>Post-Dialysis Assessment</h2>
                <p>Patients Education Self-Weighing<br> Indicator Assessment <br> Quality Control & Disinfection</p>
              </div>
            </div>
          </div>
        </div>
        <div class="ios-content">
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon1.webp" alt=""></div>
              <div class="right">
                <h2>Dialysis Preparation</h2>
                <p>EMR Registration&Scheduling <br>Patient Status  Dialysis Types</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon2.webp" alt=""></div>
              <div class="right">
                <h2>Rapid Reception</h2>
                <p>Scheduling  Auto Weighing<br> Treatment Plan  Quick Bind <br>Identification</p>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="arrow"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon6.webp" alt=""></div>
              <div class="right">
                <h2>Post-Dialysis Assessment</h2>
                <p>Patients Education Self-Weighing<br> Indicator Assessment <br> Quality Control & Disinfection</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/left.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon3.webp" alt=""></div>
              <div class="right">
                <h2>On Dialysis</h2>
                <p>Medical Advice Formulation Medical Advice Push Dialysis Monitoring Medical Supplies<br> Dialysis Machine Online</p>
              </div>
            </div>

          </div>
          <div class="bottom">
            <div class="arrow2"><img src="../../assets/image/News/keshi/bottom.webp" alt=""></div>
          </div>
          <div class="content">
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon5.webp" alt=""></div>
              <div class="right">
                <h2>Statistical Analysis</h2>
                <p>Medical Supplies Expenses<br> Dialysis Record  Final Medical Advice</p>
              </div>
            </div>
            <div class="arrow"><img src="../../assets/image/News/keshi/right.webp" alt=""></div>
            <div class="box animate__animated wow animate__fadeIn">
              <div class="left"><img src="../../assets/image/News/keshi/icon4.webp" alt=""></div>
              <div class="right">
                <h2>Daily Management</h2>
                <p>Inventory  Equipment<br> Historical Data  Medical Documents</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1s">
          <div class="pic"><img src="../../assets/image/News/keshi/keshi2.webp" alt="">
            <div class="bg">Real-Time Data  Intelligent Scheduling  Rich Statistical Reports  Standardized Workflow Shareable Medical Information</div>
          </div>
          <div class="txt">Multi-Terminal Management</div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1.4s">
          <div class="pic"><img src="../../assets/image/News/keshi/keshi3.webp" alt="">
            <div class="bg">Patients quickly use dialysis machines, dialysis plan formulation, featured medical labels, bedside medical order execution, dialysis index evaluation, and rapid data query</div>
          </div>
          <div class="txt">Mobile Medical Station</div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp" data-wow-duration="1.8s">
          <div class="pic"><img src="../../assets/image/News/keshi/keshi4.webp" alt="">
            <div class="bg">"Software and hardware compatible" patient self-help system, hemodialysis Internet of Things, data collection automation, simplifying complicated work and liberating labor</div>
          </div>
          <div class="txt">Automated Patient Data Collection</div>
        </div>
      </div>
    </div>
    <footerCard name="Mr Lin" phone="135-2227-8747"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card2.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {
      //  移动端导航
      IosList: [
        {
          id: 1,
          title: '患者管理',
          name: 'huanzhe'
        },
        {
          id: 2,
          title: '药品管理',
          name: 'yaopin'
        }, {
          id: 3,
          title: '耗材管理',
          name: 'haocai'
        }, {
          id: 4,
          title: '透析管理',
          name: 'touxi'
        }, {
          id: 5,
          title: '医嘱管理',
          name: 'yizhu'
        }, {
          id: 6,
          title: '人员管理',
          name: 'renyuan'
        }, {
          id: 7,
          title: '设备管理',
          name: 'shebei'
        },
        {
          id: 8,
          title: '字典管理',
          name: 'zidian'
        },
        {
          id: 9,
          title: '系统管理',
          name: 'xitong'
        }, {
          id: 10,
          title: '历史数据',
          name: 'lishi'
        }, {
          id: 11,
          title: '医疗文书',
          name: 'yiliao'
        }, {
          id: 12,
          title: '统计分析',
          name: 'tongji'
        }, {
          id: 13,
          title: '质控上报',
          name: 'zhikong'
        }, {
          id: 14,
          title: '排班管理',
          name: 'paiban'
        }
      ],
      // 左导航
      leftList: [
        {
          id: 1,
          title: '患者管理',
          name: 'huanzhe'
        },
        {
          id: 2,
          title: '药品管理',
          name: 'yaopin'
        }, {
          id: 3,
          title: '耗材管理',
          name: 'haocai'
        }, {
          id: 4,
          title: '透析管理',
          name: 'touxi'
        }, {
          id: 5,
          title: '医嘱管理',
          name: 'yizhu'
        }, {
          id: 6,
          title: '人员管理',
          name: 'renyuan'
        }, {
          id: 7,
          title: '设备管理',
          name: 'shebei'
        }
      ],
      // 右导航
      rightList: [
        {
          id: 8,
          title: '字典管理',
          name: 'zidian'
        },
        {
          id: 9,
          title: '系统管理',
          name: 'xitong'
        }, {
          id: 10,
          title: '历史数据',
          name: 'lishi'
        }, {
          id: 11,
          title: '医疗文书',
          name: 'yiliao'
        }, {
          id: 12,
          title: '统计分析',
          name: 'tongji'
        }, {
          id: 13,
          title: '质控上报',
          name: 'zhikong'
        }, {
          id: 14,
          title: '排班管理',
          name: 'paiban'
        }
      ],
      // 主体内容
      inList: {
        pic: require("../../assets/image/News/keshi/xitong/xitong1.webp"),
        txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
      },
      glID: ''
    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {

  },
  methods: {
    clickChange(item) {
      this.glID = item.id
      if (item.name == 'huanzhe') {
        this.inList = {
          pic: require("../../assets/image/News/keshi/xitong/xitong1.webp"),
          txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
        }
      } else {
        this.inList = {
          pic: require("../../assets/image/News/keshi/xitong/xitong1.webp"),
          txt: ['患者信息', '状态查询', '临时透析排班', '长期透析排班', '快捷搜索', '患者档案']
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.keshi {
  #liClick {
    color: #fff !important;
    background-color: #0ca6eb !important;
    position: relative;
  }
  #liClick::after {
    @media screen and (max-width: 540px) {
      content: none;
    }
    position: absolute;
    right: -0.2105rem;
    top: 0.3158rem;
    content: '';
    width: 0;
    height: 0;
    border-top: 0.1053rem solid transparent;
    border-left: 0.2105rem solid #0ca6eb;
    border-bottom: 0.1053rem solid transparent;
  }
  #liClick2 {
    color: #fff !important;
    background-color: #0ca6eb !important;
    position: relative;
  }
  #liClick2::after {
    @media screen and (max-width: 540px) {
      content: none;
    }
    position: absolute;
    left: -0.2105rem;
    top: 0.3158rem;
    content: '';
    width: 0;
    height: 0;
    border-top: 0.1053rem solid transparent;
    border-right: 0.2105rem solid #0ca6eb;
    border-bottom: 0.1053rem solid transparent;
  }
  .zhitou {
    .title {
      padding: 1rem 0 1.4316rem 0;
      @media screen and (max-width: 540px) {
        padding: 35px 0 50px 0;
      }
    }
    .content {
      height: 5.2632rem;
      display: flex;
      align-items: center;
      margin-bottom: 2.2632rem;
      @media screen and (max-width: 540px) {
        display: block;
        width: 100%;
        height: 100%;
        padding: 0 37px;
        box-sizing: border-box;
      }
      .left {
        @media screen and (max-width: 540px) {
          width: 100%;
          font-size: 16px;
          line-height: 26px;
          margin: 0;
        }
        width: 5.0526rem;
        margin-right: 1.6842rem;
        margin-left: 3.8947rem;
        color: #272b2d;
        line-height: 0.4rem;
        font-size: 0.2526rem;
      }
      .right {
        width: 7rem;
        @media screen and (max-width: 540px) {
          width: 100%;
          margin-top: 20px;
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .title2 {
      padding-bottom: 0.6105rem;
    }
  }

  .xinxi {
    .header {
      height: 9.8947rem;
      background-color: #fbfbfb;
      @media screen and (max-width: 540px) {
        height: 100%;
      }
      .header-title {
        padding: 0.9684rem 0 0.6526rem 0;
        font-size: 0.4rem;
        color: #0ca6eb;
        text-align: center;
        font-weight: 600;
        @media screen and (max-width: 540px) {
          font-size: 19px;
        }
      }
      .ios-content {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
        }
        padding-bottom: 20px;
        .contentmenu {
          padding: 0 14px;
          overflow: hidden;
          li {
            float: left;
            width: 23%;
            margin: 2px;
            height: 42px;
            line-height: 42px;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            color: #666666;
            font-size: 13px;
            text-align: center;
          }
        }
        .in {
          width: 86%;
          height: 100%;
          margin: 0 auto;
          .pic {
            width: 100%;
            height: 172px;
            margin: 30px 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            width: 100%;
            overflow: hidden;
            li {
              float: left;
              width: 33%;
              padding: 0.2632rem 0;
              text-align: center;
              color: #666666;
              font-size: 0.2947rem;
              border-bottom: 1px solid #eaeaea;
              border-left: 1px solid #eaeaea;
              @media screen and (max-width: 540px) {
                font-size: 12px;
              }
            }
            li:nth-child(1) {
              border-left: none;
            }
            li:nth-child(4) {
              border-bottom: none;
              border-left: none;
            }
            li:nth-child(5) {
              border-bottom: none;
            }
            li:nth-child(6) {
              border-bottom: none;
            }
          }
        }
      }
      .header-content {
        @media screen and (max-width: 540px) {
          display: none;
        }
        padding: 0 1.6842rem;
        display: flex;
        align-items: center;
        .left {
          width: 2.6737rem;
          li {
            width: 100%;
            height: 0.8842rem;
            text-align: center;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            color: #666666;
            cursor: pointer;
            line-height: 0.8842rem;
            font-size: 0.2737rem;
            border-radius: 0.0421rem;
            margin-bottom: 0.1684rem;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
        .in {
          width: 8rem;
          height: 6.3158rem;
          padding: 0 1.7895rem;
          .pic {
            width: 100%;
            height: 4.0211rem;
            margin-bottom: 0.3158rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .txt {
            width: 100%;
            overflow: hidden;

            li {
              float: left;
              width: 33%;
              padding: 0.2632rem 0;
              text-align: center;
              color: #666666;
              font-size: 0.2947rem;
              border-bottom: 1px solid #eaeaea;
              border-left: 1px solid #eaeaea;
            }
            li:nth-child(1) {
              border-left: none;
            }
            li:nth-child(4) {
              border-bottom: none;
              border-left: none;
            }
            li:nth-child(5) {
              border-bottom: none;
            }
            li:nth-child(6) {
              border-bottom: none;
            }
          }
        }
        .right {
          width: 2.6737rem;
          li {
            width: 100%;
            height: 0.8842rem;
            text-align: center;
            color: #666666;
            line-height: 0.8842rem;
            font-size: 0.2737rem;
            cursor: pointer;
            background-color: #ffffff;
            border: 1px solid #eaeaea;
            border-radius: 0.0421rem;
            margin-bottom: 0.1684rem;
          }
          li:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .main {
      height: 9.0526rem;
      background: url('../../assets/image/News/keshi/bg1.webp') no-repeat;
      background-size: 100% 100%;
      @media screen and (max-width: 540px) {
        height: 760px;
        background-size: cover;
      }
      .titletxt {
        text-align: center;
        color: #0ca6eb;
        font-weight: 700;
        font-size: 0.4rem;
        padding: 1.3684rem 0;
        @media screen and (max-width: 540px) {
          font-size: 19px;
        }
      }
      .ios-content {
        display: none;
        @media screen and (max-width: 540px) {
          display: block;
          padding: 0 5px;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          .box {
            width:258px;
            height: 186px;
            background: #ffffff;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            .left {
              width: 26px;
              height: 26px;
              margin: 0 0.3368rem 0 0.3895rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right {
              flex: 1;
              h2 {
                margin: 0;
                padding-bottom: 10px;
                font-size: 14px;
                color: #000000;
              }
              p {
                font-size: 10px;
                color: #666666;
                line-height: 18px;
              }
            }
          }
          .box:hover {
            h2 {
              color: #0ca6eb;
            }
          }
          .arrow {
            width: 44px;
            height: 21px;
            margin: 0 0.2316rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bottom {
          height: 52px;
          position: relative;
          .arrow {
            position: absolute;
            width: 21px;
            height: 44px;
            right: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .arrow2 {
            position: absolute;
            width: 21px;
            height: 44px;
            left: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .pc-content {
        @media screen and (max-width: 540px) {
          display: none;
        }
        .content {
          display: flex;
          justify-content: center;
          align-items: center;
          .box {
            width: 4.2737rem;
            height: 1.8105rem;
            background: #ffffff;
            border: 1px solid #eaeaea;
            display: flex;
            align-items: center;
            .left {
              width: 0.6105rem;
              height: 0.6105rem;
              margin: 0 0.3368rem 0 0.3895rem;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .right {
              flex: 1;
              h2 {
                margin: 0;
                padding-bottom: 0.0947rem;
                font-size: 0.2247rem;
                color: #000000;
              }
              p {
                font-size: 0.155rem;
                color: #666666;
                line-height: 0.2842rem;
              }
            }
          }
          .box:hover {
            h2 {
              color: #0ca6eb;
            }
          }
          .arrow {
            width: 0.9263rem;
            height: 0.4421rem;
            margin: 0 0.2316rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bottom {
          height: 1rem;
          position: relative;
          .arrow {
            position: absolute;
            width: 0.4421rem;
            height: 0.7368rem;
            right: 4rem;
            top: 0.1579rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .footer::-webkit-scrollbar {
      display: none;
    }
    .footer {
      height: 6.2105rem;
      padding: 1.1579rem 0 1.3158rem 0;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 540px) {
        padding: 0 7px;
        height: 100%;
        margin: 18px 0 56px 0;
        overflow: scroll;
        overflow-y: hidden;
        justify-content: left;
      }
      .box {
        width: 5.3684rem;
        margin: 0 0.1579rem;
        cursor: pointer;
        background-color: #fbfbfb;
        @media screen and (max-width: 540px) {
          margin: 0 7px;
          flex-basis: 250px;
          flex-shrink: 0;
        }
        .pic {
          height: 5.1789rem;
          position: relative;
          @media screen and (max-width: 540px) {
            height: 246px;
            width: 100%;
          }
          img {
            width: 100%;
            height: 100%;
          }
          .bg {
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 0.2526rem;
            padding: 0.5895rem;
            line-height: 0.4211rem;
            opacity: 0.8;
            text-align: center;
            box-sizing: border-box;
            background: rgba(0, 0, 0, 0.5);
            @media screen and (max-width: 540px) {
              line-height: 25px;
              font-size: 12px;
            }
          }
        }
        .txt {
          margin-top: -0.0211rem;
          height: 1.0526rem;
          line-height: 1.0526rem;
          color: #666666;
          font-size: 0.2947rem;
          text-align: center;
          @media screen and (max-width: 540px) {
            height: 50px;
            line-height: 50px;
          }
        }
      }
      .box:hover {
        background-color: #0ca6eb;
        .txt {
          color: #fff;
        }
        .pic {
          .bg {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
}
</style>
